<template>
<div class="chapter">
<div class="inner_page">
<p class="C243"><strong><a id="page_17">PART ONE</a></strong></p><a id="page_17">
<p class="C244">Understanding Resistance to Affirmative Action</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Part_I__Understanding_Resistance.vue?6829916e